import React, { useCallback, useEffect } from "react";
import { IconWrapper } from "./IconWrapper";
import { useRomaine } from "romaine";

export const UndoIcon = (
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
) => {
  const {
    setMode,
    romaine: {
      history: { pointer },
    },
  } = useRomaine();
  // using keydown because it already requires another key to be pressed
  const eventListenerCropper = useCallback(
    (e: KeyboardEvent) => {
      if (e.ctrlKey && /z/i.test(e.key)) {
        e.preventDefault();
        pointer && setMode?.("undo");
      }
    },
    [pointer, setMode]
  );
  useEffect(() => {
    window.removeEventListener("keydown", eventListenerCropper);
    window.addEventListener("keydown", eventListenerCropper);
    return () => {
      window.removeEventListener("keydown", eventListenerCropper);
    };
  }, [eventListenerCropper]);
  return (
    <IconWrapper
      {...props}
      onClick={() => setMode && setMode("undo")}
      selected="undo"
      tooltip="Undo (Ctrl + Z)"
      disabled={!pointer}
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="0"
        viewBox="0 0 1024 1024"
        height="25px"
        width="25px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"></path>
      </svg>
    </IconWrapper>
  );
};
